import { useCallback, useRef } from 'react';

export default function useLatestRequestGuard() {
  const requestSequenceRef = useRef(0);

  const beginRequest = useCallback(() => {
    const requestId = ++requestSequenceRef.current;
    return {
      isCurrent: () => requestSequenceRef.current === requestId,
    };
  }, []);

  const invalidateRequests = useCallback(() => {
    requestSequenceRef.current += 1;
  }, []);

  return { beginRequest, invalidateRequests };
}
